import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface CreateSendToVendorProps {
    sendToVendor: boolean;
    setSendToVendor: (value: boolean) => void;
    vendorEmail: string;
    setVendorEmail: (value: string) => void;
    busy: boolean;
}

const CreateSendToVendor = ({
    sendToVendor,
    setSendToVendor,
    vendorEmail,
    setVendorEmail,
    busy,
}: CreateSendToVendorProps) => {
    const { t } = useTranslation(['Warehouses', 'common']);

    return (
        <div className="mx-3 mb-3">
            <div className="form-check form-switch mb-0">
                <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="supplier-request-send-to-vendor"
                    checked={sendToVendor}
                    disabled={busy}
                    onChange={(e) => setSendToVendor(Boolean(e.target.checked))}
                />
                <label
                    className="form-check-label"
                    htmlFor="supplier-request-send-to-vendor"
                >
                    {t('supplierRequests.create.sendToVendorLabel')}
                </label>
                <div className="small text-muted">
                    {t('supplierRequests.create.sendToVendorHint')}
                </div>
            </div>

            {sendToVendor ? (
                <Form.Group className="mt-3 mb-0">
                    <Form.Label>
                        {t('supplierRequests.create.vendorEmailLabel')}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={vendorEmail}
                        disabled={busy}
                        onChange={(e) => setVendorEmail(e.target.value)}
                        placeholder={t('supplierRequests.create.vendorEmailPlaceholder')}
                        autoComplete="email"
                    />
                </Form.Group>
            ) : null}
        </div>
    );
};

export default CreateSendToVendor;
